import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Lock, Phone, Envelope, ArrowRight } from '@phosphor-icons/react';

const AdminProfileUpdate = ({ adminId, currentPhone, currentEmail }) => {
  const navigate = useNavigate();

  const profileOptions = [
    {
      id: 'password',
      title: 'Change Password',
      icon: Lock,
      color: 'from-purple-500 to-purple-600',
      description: 'Update your account password',
      route: '/admin-change-password'
    },
    {
      id: 'mobile',
      title: 'Change Mobile Number',
      icon: Phone,
      color: 'from-blue-500 to-blue-600',
      description: 'Update your mobile number',
      route: '/admin-change-mobile'
    },
    {
      id: 'email',
      title: 'Change Email',
      icon: Envelope,
      color: 'from-green-500 to-green-600',
      description: 'Update your email address',
      route: '/admin-change-email'
    }
  ];

  return (
    <div className="bg-white rounded-lg border border-gray-200 p-6">
      <div className="flex items-center gap-3 mb-6">
        <Lock size={28} weight="bold" className="text-green-600" />
        <div>
          <h2 className="text-xl font-bold text-gray-800">Update Admin Profile</h2>
          <p className="text-sm text-gray-500">Manage your account settings securely</p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {profileOptions.map((option) => {
          const Icon = option.icon;
          return (
            <button
              key={option.id}
              onClick={() => navigate(option.route)}
              className="group relative bg-white border-2 border-gray-200 rounded-xl p-6 hover:border-gray-300 hover:shadow-lg transition-all duration-200"
            >
              {/* Icon Background */}
              <div className={`w-14 h-14 bg-gradient-to-br ${option.color} rounded-lg flex items-center justify-center mb-4 group-hover:scale-110 transition-transform`}>
                <Icon size={28} weight="bold" className="text-white" />
              </div>

              {/* Title & Description */}
              <h3 className="text-lg font-bold text-gray-800 mb-2">{option.title}</h3>
              <p className="text-sm text-gray-600 mb-4">{option.description}</p>

              {/* Arrow */}
              <div className="flex items-center justify-between">
                <span className="text-xs text-gray-500">Click to update</span>
                <ArrowRight size={20} weight="bold" className="text-gray-400 group-hover:text-gray-600 group-hover:translate-x-1 transition-all" />
              </div>
            </button>
          );
        })}
      </div>

      {/* Current Info Display */}
      <div className="mt-6 pt-6 border-t border-gray-200">
        <h3 className="text-sm font-semibold text-gray-700 mb-3">Current Information</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          <div className="bg-gray-50 rounded-lg p-3">
            <p className="text-xs text-gray-500 mb-1">Mobile Number</p>
            <p className="text-sm font-semibold text-gray-800">{currentPhone || 'Not set'}</p>
          </div>
          <div className="bg-gray-50 rounded-lg p-3">
            <p className="text-xs text-gray-500 mb-1">Email Address</p>
            <p className="text-sm font-semibold text-gray-800">{currentEmail || 'Not set'}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminProfileUpdate;
